export const CreateButtonId = {
    AddDevBox: 'ActionBar_AddDevBoxButton',
    AddEnvironment: 'ActionBar_AddEnvironmentButton',
    New: 'ActionBar_NewButton',
} as const;

export const getCreateButtonToFocusOnDismiss = (directButtonId: string): HTMLElement | undefined =>
    document.getElementById(CreateButtonId.New) ?? document.getElementById(directButtonId) ?? undefined;
